<template>
    <div v-if="bewerb" class="title my-1" style="line-height: 1.2">
        <div>{{meisterschaftName}} {{bewerb.settings.sportJahr.replace('_', '/')}}</div>
        <div>{{bewerb.settings.meisterschaftName}}, {{bewerbName}} <slot></slot></div>
    </div>
</template>

<script>
import {MEISTERSCHAFT_BEWERBE} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "meisterschaftPrintBewerbName",
    props: ['bewerb'],
    computed: {
        landesverbandRaw(){return this.bewerb?.settings.lvId==="1"? this.$store.state.local.nationaleLigen :
            this.$store.state.local.landesverbaende.find(lv => lv.id === this.bewerb?.settings.lvId) },
        ligaType(){ return this.$store.state.local.ligaTypes.find(type => type.value === this.bewerb.settings.meisterschaftType) },
        ligaLabelLong(){ return this.landesverbandRaw?.id==='1' ? this.ligaType.labelLong : this.ligaType.labelLongAlt },
        bewerbName() {
            return this.meisterschaftBewerbe.find(b => b.value === this.bewerb?.settings?.bewerbTyp)?.label
        },
        meisterschaftName(){ return this.landesverbandRaw?.prefix + this.ligaLabelLong }
    },
    data: () => ({
        meisterschaftBewerbe: MEISTERSCHAFT_BEWERBE
    }),
}
</script>

<style scoped>

</style>